function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAmbulance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0A78B6",
    style: {
      fill: "#0a78b6",
      fill: "color(display-p3 .0392 .4706 .7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#0A78B6",
    style: {
      fill: "#0a78b6",
      fill: "color(display-p3 .0392 .4706 .7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.898 18.997c1.187.03 1.187 1.77 0 1.8-1.186-.03-1.186-1.77 0-1.8m10.202 0c1.186.03 1.186 1.77 0 1.8-1.187-.03-1.187-1.77 0-1.8",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.298 17.686c0-.67.476-1.25 1.132-1.382l1.411-.282 2.173-2.413a1.85 1.85 0 0 1 1.284-.607v-.605a.9.9 0 0 1 1.8 0v.234a.9.9 0 0 1 .6-.234H24.1a.9.9 0 0 1 .9.9v6.3a.9.9 0 0 1-.9.9h-1.305c-.546 1.588-2.852 1.583-3.392-.004-2.909.007-4.66.004-6.81.004-.546 1.585-2.845 1.584-3.39 0h-1.27c-.836.016-1.258-1.069-.635-1.624zM22.9 19.897h1.2a.3.3 0 0 0 .3-.3v-.3h-1.605c.069.186.105.39.105.6m-1.8 1.2c1.582-.046 1.589-2.349 0-2.4-1.59.052-1.582 2.354 0 2.4m-5.701-1.2h3.9c0-.21.036-.414.105-.6H15.4zm0-2.7h9v-3.9a.3.3 0 0 0-.3-.3h-8.4a.3.3 0 0 0-.3.3zm-4.501 3.9c1.586-.05 1.586-2.35 0-2.4-1.586.05-1.586 2.35 0 2.4m-2.964-1.2h1.164c.085-2.383 3.517-2.381 3.6 0H14.8v-6.3c-.156-.003-1.29.002-1.41 0-.353 0-.692.15-.928.414l-2.24 2.487a.3.3 0 0 1-.164.094l-1.509.301a.8.8 0 0 0-.482.304c1.275-.099 1.406 1.737.132 1.8h-.3c.01.135-.114.241-.202.326-.212.2-.054.583.238.574",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.684 14.21c.335-.428 1.047-.296 1.515-.314a.3.3 0 0 1 .3.3v2.7a.3.3 0 0 1-.3.3h-3.53c-.25.009-.398-.318-.222-.5zm.615 4.787h.9c.393.007.394.593 0 .6h-.9c-.394-.007-.395-.593 0-.6m.6-8.101v-.6c.006-.395.593-.395.6 0v.6c-.007.395-.594.395-.6 0m1.361.74c-.256.009-.403-.334-.212-.513l.424-.424c.279-.276.7.145.425.424-.203.178-.452.535-.636.513m-2.263.76a.3.3 0 0 1-.3.3h-.6a.3.3 0 1 1 0-.6h.6a.3.3 0 0 1 .3.3m-.072-1.697.424.424c.276.279-.145.7-.424.425l-.425-.425c-.276-.278.146-.7.425-.424m5.774 3.798h.6v-.6a.3.3 0 0 1 .3-.3h.6a.3.3 0 0 1 .3.3v.6h.6a.3.3 0 0 1 .3.3v.6a.3.3 0 0 1-.3.3h-.6v.6a.3.3 0 0 1-.3.3h-.6a.3.3 0 0 1-.3-.3v-.6h-.6a.3.3 0 0 1-.3-.3v-.6a.3.3 0 0 1 .3-.3",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAmbulance);
export default __webpack_public_path__ + "static/media/ic_ambulance.26d4445e66a9d8819789c6918cb0531c.svg";
export { ForwardRef as ReactComponent };